import { DatePickerValue } from "shared/ui";

export interface AllReportsParams {
  offset?: number | null;
  limit?: number | null;
  expand?: string;
  ordering?: string;
  report_type?: string;
  name__in?: string[];
  template_id__in?: string;
  report_type__in?: string[];
  report__name__in?: string[];
  recipients?: string;
  periodicity?: string;
  report_category__name__icontains?: string;
  is_default?: boolean;
}

export const enum ReportType {
  MATERIAL_ITEM = "MATERIAL_ITEM",
  PACKAGING = "PACKAGING",
  REEL_LAB_ARCHIVE = "REEL_LAB_ARCHIVE",
  ORDER = "ORDER",
  MULTIPLE_ORDER = "MULTIPLE_ORDER",
  MULTIPLE_PACKAGING = "MULTIPLE_PACKAGING",
  MULTIPLE_COMPANY_PACKAGING = "MULTIPLE_COMPANY_PACKAGING",
  MULTIPLE_ORDER_PACKAGING = "MULTIPLE_ORDER_PACKAGING",
  MULTIPLE_MATERIAL = "MULTIPLE_MATERIAL",
  MULTIPLE_QUALITY = "MULTIPLE_QUALITY",
  MULTIPLE_MATERIAL_ITEM = "MULTIPLE_MATERIAL_ITEM",
  MANAGEMENT = "MANAGEMENT",
  DRIGGING_RIGG = "DRIGGING_RIGG",
  STOCK = "STOCK",
  QUALITY_ADHESION = "QUALITY_ADHESION",
}

export interface ReportItem {
  id: number;
  name: string;
  template_id: string;
  report_type: ReportType;
  template_format: string;
  report_category: {
    id: number;
    name: string;
  };
  is_default: boolean;
}

export interface UpdateReportItem {
  id: number;
  name: string;
  template_id: string;
  report_type: ReportType;
  template_format: string;
  report_category: number;
  is_default: boolean;
}

export interface CreateReport {
  name: string;
  template_id: string;
  report_type: ReportType;
  template_format: string;
  is_default: boolean;
}

export interface ReportsResponse {
  count: number;
  next: string;
  previous: string;
  results: ReportItem[];
}

export type ReportFormat =
  | "ods"
  | "xlsx"
  | "xls"
  | "csv"
  | "pdf"
  | "txt"
  | "odp"
  | "ppt"
  | "pptx"
  | "jpg"
  | "png"
  | "odt"
  | "doc"
  | "docx"
  | "epub"
  | "html"
  | "xml"
  | "idml";

export enum ReportFormatEnum {
  ODS = "ods",
  XLSX = "xlsx",
  XLS = "xls",
  CSV = "csv",
  PDF = "pdf",
  TXT = "txt",
  ODP = "odp",
  PPT = "ppt",
  PPTX = "pptx",
  JPG = "jpg",
  PNG = "png",
  ODT = "odt",
  DOC = "doc",
  DOCX = "docx",
  EPUB = "epub",
  HTML = "html",
  XML = "xml",
  IDML = "idml",
}

export interface ExecuteReport {
  id: number | null;
  material_item_id: number | null;
  packaging_id: number | null;
  order_id: number | null;
  material_id: number | null;
  // order_wanted_delivery_datetime_start: DatePickerValue;
  // order_wanted_delivery_datetime_end: DatePickerValue;
  order_production_datetime_start: DatePickerValue | string;
  order_production_datetime_end: DatePickerValue | string;
  report_format: ReportFormat;
  quality_result_id: number | null;
  packaging_ids: number[] | null;

  drigging_rigg_field: string | null;
  drigging_rigg_datetime_start: DatePickerValue;
  drigging_rigg_datetime_end: DatePickerValue;
  drigging_rigg_n_points: number | null;
  company_id: number | null;
  material_category_id_list: number[];
  order_ids: number[];
  material_category_id: number | null;
  dynamic_tracker_fields: string[];
}

interface BaseReportSchedule {
  recipients: string[];
  is_recurrent: boolean | null;
  periodicity: string | null;
  email_body: string | null;
  email_subject: string;
  time: string | null;
  start_periodicity: string | null;
  end_periodicity: string | null;
  enabled: boolean;
  report: number;
  next_execution?: string | null;
  last_execution?: string | null;
}

export interface GetReportSchedules extends BaseReportSchedule {
  id: number;
}

export type CreateReportSchedules = BaseReportSchedule;

export interface GetReportSchedulesWithExtendedReport
  extends Omit<BaseReportSchedule, "report"> {
  id: number;
  report: {
    id: number;
    name: string;
  };
}
